import Styles from "./styles.module.css";
import Logo from "./../../../../image/login/icon.png";

const HomeLogo = () => {
  return (
    <>
    <div className={Styles.logo}>
      <p>利用していただいている事業者様</p>
      <img src={Logo} />
    </div>
    </>
    // <div className={Styles.logo}>
    //   <div className={Styles.track}>
    //     <img src={Logo} alt="logos" />
    //     <img src={Logo} alt="logos" />
    //   </div>
    // </div>
  );
};

export default HomeLogo;